"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visuallyHidden = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Text a screen reader reads and a sighted reader never sees: kept in the
 * accessibility tree at its full length, drawn in no space at all. For a name
 * the screen already says another way, such as a heading spelled out in
 * pictures or a count drawn as rolling digits.
 */
const visuallyHidden = exports.visuallyHidden = {
  text: {
    position: "x10l6tqk",
    width: "x1i1rx1s",
    height: "xjm9jq1",
    margin: "xkdpibf",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    clipPath: "x1hyvwdk",
    whiteSpace: "xuxw1ft",
    $$css: true
  }
};